import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "br_token_v1";

// Session is primarily an httpOnly cookie (carried by withCredentials).
// As a belt-and-suspenders fallback for production custom-domain setups
// where the cookie can be stripped by the ingress, we also persist the
// JWT returned by /auth/login (or /auth/register) and attach it as a
// Bearer header on every request. Backend accepts either.
export function setStoredToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch { /* private mode / disabled storage — best effort only */ }
}

export function getStoredToken() {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
}

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const t = getStoredToken();
  if (t && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

// Clear stored token on any 401 so the next page load redirects to login
// instead of looping with a stale token. For admin pages we also push the
// browser to /login so the user gets an obvious recovery path.
api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401) {
      const url = error.config?.url || "";
      const onAdminPage = typeof window !== "undefined" &&
        window.location.pathname.startsWith("/admin");
      // Don't clear if this was just /auth/me probing — that endpoint
      // is supposed to return 401 for guests.
      if (!url.includes("/auth/me")) {
        if (onAdminPage) {
          // Token is dead AND the user is trying to use an admin surface.
          // Wipe stored token and bounce to login so they aren't stuck
          // staring at "Couldn't load" errors with no recourse.
          setStoredToken(null);
          const next = encodeURIComponent(window.location.pathname);
          window.location.assign(`/login?next=${next}&reason=expired`);
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
